/* Cart extras (drawer + cart page), like Amazon:
   - "Add to wishlist"  (keeps the item in the cart, saves it to the same wishlist as the hearts)
   - "Save for later"   (takes the item out of the cart, keeps it in a "Saved for later" list below the cart)
   Lab Certificate / Energised add-ons are never shown with these buttons. They follow their product:
   when a product is saved for later its add-ons go with it, and come back with it on "Move to cart".
   Everything is stored on the customer's phone/browser (no login needed), same as the wishlist. */
(function () {
  if (window.__nvCx) return;
  window.__nvCx = true;

  var WKEY = 'nv_wishlist_v1', SKEY = 'nv_saved_v1';
  var cfg = window.nvShop || {};
  var wishlistOn = cfg.wishlist !== false;

  function jget(k) { try { var a = JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function jset(k, a) { try { localStorage.setItem(k, JSON.stringify(a)); } catch (e) { /* private mode */ } }
  function root() { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(html) { if (window.NvCore && NvCore.toast) NvCore.toast(html); }
  // Liquid prints an item with no properties as [] (an empty array); Shopify wants a hash {}
  function hash(o) { return o && typeof o === 'object' && !Array.isArray(o) ? o : {}; }
  function parse(s) { try { return hash(JSON.parse(s || '{}')); } catch (e) { return {}; } }
  function sig(e) { return e.vid + '|' + JSON.stringify(hash(e.props)); }

  var HEART = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 2.7 5 6 5c2 0 3.4 1.1 4.2 2.4h3.6C14.6 6.1 16 5 18 5c3.3 0 5.1 3.4 3.6 6.8C19.5 16.4 12 21 12 21z"/></svg>';

  /* ---------- wishlist (same list as the hearts on product cards) ---------- */
  function wlHas(h) {
    if (window.NvWishlist) return NvWishlist.has(h);
    return jget(WKEY).indexOf(h) > -1;
  }
  function wlToggle(h) {
    if (window.NvWishlist) return NvWishlist.toggle(h);
    var a = jget(WKEY), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    jset(WKEY, a.slice(0, 100));
    document.dispatchEvent(new CustomEvent('nv:wishlist', { detail: a }));
    return i === -1;
  }

  /* ---------- network (XHR on purpose: the festival add-to-cart animation only listens to fetch) ---------- */
  function post(url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', url);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        var j = null; try { j = JSON.parse(x.responseText); } catch (e) { /* not json */ }
        if (x.status >= 200 && x.status < 300) resolve(j); else reject(j || {});
      };
      x.onerror = function () { reject({}); };
      x.send(JSON.stringify(body));
    });
  }
  function getCart() {
    return fetch(root() + 'cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function updateCounts(cart) {
    if (!cart) return;
    var n = cart.item_count;
    document.querySelectorAll('[data-cart-count], [data-cart-badge], .cart-count-bubble > span[aria-hidden]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n < 1);
    });
    document.querySelectorAll('[class*="cart-count"]:not(.cart-count-bubble)').forEach(function (el) {
      if (el.children.length === 0) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; }
    });
  }

  /* re-draw the cart (drawer or page) from the server */
  function refresh(cart, inDrawer) {
    updateCounts(cart);
    if (inDrawer) {
      var d = document.querySelector('cart-drawer');
      return d && d.refreshFromServer ? d.refreshFromServer() : Promise.resolve();
    }
    var ci = document.querySelector('cart-items');
    if (!ci || !ci.getSectionsToRender) { location.reload(); return Promise.resolve(); }
    var list = ci.getSectionsToRender();
    var ids = list.map(function (s) { return s.section; }).join(',');
    return fetch(window.location.pathname + '?sections=' + ids + '&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        list.forEach(function (s) {
          var host = document.getElementById(s.id);
          if (!host || !data[s.section]) return;
          var target = host.querySelector(s.selector) || host;
          var src = new DOMParser().parseFromString(data[s.section], 'text/html').querySelector(s.selector);
          if (src) target.innerHTML = src.innerHTML;
        });
        ci.classList.toggle('is-empty', cart.item_count === 0);
      })
      .catch(function () { location.reload(); });
  }

  /* ---------- actions ---------- */
  function addonsOf(row) {
    var scope = row.closest('tbody') || row.parentElement;
    var mine = row.getAttribute('data-nv-for');
    return Array.prototype.filter.call(scope.querySelectorAll('tr.cart-item[data-nv-addon]'), function (r) {
      return r.getAttribute('data-nv-for') === mine || (r.getAttribute('data-nv-props') && parse(r.getAttribute('data-nv-props'))['For Product'] === mine);
    });
  }
  function entryOf(row) {
    return {
      vid: row.getAttribute('data-nv-vid'),
      handle: row.getAttribute('data-nv-handle'),
      title: row.getAttribute('data-nv-title'),
      vtitle: row.getAttribute('data-nv-vtitle'),
      url: row.getAttribute('data-nv-url'),
      img: row.getAttribute('data-nv-img'),
      price: row.getAttribute('data-nv-price'),
      qty: Math.max(1, parseInt(row.getAttribute('data-nv-qty'), 10) || 1),
      props: parse(row.getAttribute('data-nv-props')),
      addons: []
    };
  }

  function saveForLater(row, btn) {
    var inDrawer = !!row.closest('cart-drawer');
    var e = entryOf(row);
    var updates = {};
    updates[row.getAttribute('data-nv-key')] = 0;
    addonsOf(row).forEach(function (a) {
      var x = entryOf(a);
      e.addons.push({ vid: x.vid, qty: x.qty, props: x.props, title: x.title, price: x.price });
      updates[a.getAttribute('data-nv-key')] = 0;
    });
    btn.disabled = true;
    row.style.opacity = '.5';
    post(root() + 'cart/update.js', { updates: updates }).then(function (cart) {
      var s = jget(SKEY).filter(function (x) { return sig(x) !== sig(e); });
      s.unshift(e);
      jset(SKEY, s.slice(0, 50));
      toast('Saved for later');
      return refresh(cart, inDrawer);
    }).then(scan).catch(function (err) {
      btn.disabled = false;
      row.style.opacity = '';
      toast(esc((err && (err.description || err.message)) || 'Could not save this item. Please try again.'));
    });
  }

  function moveToCart(i, btn, inDrawer) {
    var s = jget(SKEY), e = s[i];
    if (!e) return;
    var items = [{ id: Number(e.vid), quantity: e.qty, properties: hash(e.props) }];
    (e.addons || []).forEach(function (a) { items.push({ id: Number(a.vid), quantity: a.qty, properties: hash(a.props) }); });
    btn.disabled = true;
    post(root() + 'cart/add.js', { items: items }).then(function () {
      var cur = jget(SKEY).filter(function (x) { return sig(x) !== sig(e); });
      jset(SKEY, cur);
      return getCart();
    }).then(function (cart) {
      toast('Moved to cart');
      return refresh(cart, inDrawer);
    }).then(scan).catch(function (err) {
      btn.disabled = false;
      toast(esc((err && (err.description || err.message)) || 'Sorry, this item could not be added right now.'));
    });
  }

  function deleteSaved(i) {
    var s = jget(SKEY);
    s.splice(i, 1);
    jset(SKEY, s);
    toast('Removed');
    scan();
  }

  /* ---------- buttons under every cart line ---------- */
  function paintWl(btn) {
    var on = wlHas(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.querySelector('span').textContent = on ? 'In wishlist' : 'Add to wishlist';
  }
  function decorate(row) {
    if (row.hasAttribute('data-nv-addon')) return;                // Lab Certificate / Energised: no buttons
    var host = row.querySelector('.cart-item__details');
    if (!host || host.querySelector('.nv-cx')) return;
    var handle = row.getAttribute('data-nv-handle');
    var box = document.createElement('div');
    box.className = 'nv-cx';
    box.innerHTML =
      (wishlistOn && handle ? '<button type="button" class="nv-cx__btn nv-cx__wl" data-nv-act="wl" data-handle="' + esc(handle) + '" aria-pressed="false">' + HEART + '<span>Add to wishlist</span></button>' : '') +
      '<button type="button" class="nv-cx__btn" data-nv-act="save">Save for later</button>';
    host.appendChild(box);
    var w = box.querySelector('.nv-cx__wl');
    if (w) paintWl(w);
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-nv-act]');
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();
    var act = b.getAttribute('data-nv-act');
    if (act === 'wl') {
      var added = wlToggle(b.getAttribute('data-handle'));
      paintWl(b);
      var url = cfg.wishlistUrl || '/pages/wishlist';
      toast(added ? 'Saved to your wishlist &middot; <a href="' + esc(url) + '">View</a>' : 'Removed from your wishlist');
    } else if (act === 'save') {
      var row = b.closest('tr.cart-item');
      if (row) saveForLater(row, b);
    } else if (act === 'move' || act === 'del') {
      var li = b.closest('[data-i]');
      var box = b.closest('.nv-saved');
      if (!li) return;
      var idx = parseInt(li.getAttribute('data-i'), 10);
      if (act === 'move') moveToCart(idx, b, !!(box && box.closest('cart-drawer'))); else deleteSaved(idx);
    }
  }, true);
  document.addEventListener('nv:wishlist', function () {
    document.querySelectorAll('.nv-cx__wl').forEach(paintWl);
  });

  /* ---------- "Saved for later" list ---------- */
  function savedHTML(list) {
    return '<h3 class="nv-saved__h">Saved for later (' + list.length + ' ' + (list.length === 1 ? 'item' : 'items') + ')</h3><ul class="nv-saved__list">' +
      list.map(function (e, i) {
        var addons = (e.addons || []).map(function (a) { return esc(a.title); }).join(', ');
        return '<li class="nv-saved__item" data-i="' + i + '">' +
          '<a class="nv-saved__img" href="' + esc(e.url) + '">' + (e.img ? '<img src="' + esc(e.img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
          '<div class="nv-saved__info">' +
          '<a class="nv-saved__t" href="' + esc(e.url) + '">' + esc(e.title) + '</a>' +
          (e.vtitle ? '<p class="nv-saved__v">' + esc(e.vtitle) + '</p>' : '') +
          '<p class="nv-saved__p">' + esc(e.price) + (e.qty > 1 ? ' &times; ' + e.qty : '') + '</p>' +
          (addons ? '<p class="nv-saved__a">+ ' + addons + '</p>' : '') +
          '<div class="nv-saved__act"><button type="button" class="nv-saved__move" data-nv-act="move">Move to cart</button>' +
          '<button type="button" class="nv-cx__btn" data-nv-act="del">Delete</button></div>' +
          '</div></li>';
      }).join('') + '</ul>';
  }

  function hostFor() {
    var out = [];
    var drawerItems = document.getElementById('CartDrawer-CartItems');
    var drawerEmpty = document.querySelector('cart-drawer .drawer__inner-empty');
    if (drawerItems && drawerItems.offsetParent !== null && !document.querySelector('cart-drawer.is-empty')) out.push(drawerItems);
    else if (drawerEmpty) out.push(drawerEmpty);
    var page = document.querySelector('cart-items:not(cart-drawer-items) .page-width');
    if (page) out.push(page);
    return out;
  }

  function mountSaved() {
    var list = jget(SKEY);
    var s = JSON.stringify(list);
    var hosts = hostFor();
    document.querySelectorAll('.nv-saved').forEach(function (n) {
      if (hosts.indexOf(n.parentElement) === -1 || !list.length) n.remove();
    });
    if (!list.length) return;
    hosts.forEach(function (h) {
      var n = h.querySelector(':scope > .nv-saved');
      if (!n) { n = document.createElement('section'); n.className = 'nv-saved'; n.setAttribute('aria-label', 'Saved for later'); h.appendChild(n); }
      if (n.getAttribute('data-sig') !== s) { n.innerHTML = savedHTML(list); n.setAttribute('data-sig', s); }
    });
  }

  function scan() {
    document.querySelectorAll('tr.cart-item[data-nv-key]').forEach(decorate);
    mountSaved();
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(scan, 120); }
  function boot() {
    scan();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === SKEY || e.key === WKEY) later(); });
    window.addEventListener('pageshow', later);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
